import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import { useStyles, MyLinearProgress } from "./style";

export default function MainItem({ points = 100 }) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.top}>
        <div className={classes.points}>
          <CircularProgress
            variant="determinate"
            value={90}
            size={53}
            thickness={4.5}
          />
        </div>

        <div className={classes.ptext}>
          <p style={{ fontWeight: "bold", textAlign: "center" }}>{points}</p>
          <p style={{ fontSize: 9, fontWeight: "bold", textAlign: "center" }}>
            Points
          </p>
        </div>
        <div className={classes.vs}>
          <p style={{ fontWeight: "bold", color: "#fff" }}>VS</p>
        </div>
        <div style={{ position: "relative", marginBottom: 20 }}>
          <img
            src="https://images.versus.io/objects/sony-xperia-5-ii.front.medium.1601372776500.jpg"
            className={classes.img}
          />
          <div className={classes.price}>
            <p style={{ fontWeight: "bold", color: "#fff", fontSize: 12 }}>
              25000 IND
            </p>
          </div>
        </div>
      </div>
      <Typography variant="h6" align="left">
        Sony Xperia 5 II
      </Typography>
      <div className={classes.detail}>
        <p className={classes.heading}>Design</p>
        <MyLinearProgress variant="determinate" value={30} />

        <p className={classes.heading}>Display</p>
        <MyLinearProgress variant="determinate" value={90} />

        <p className={classes.heading}>Performance</p>
        <MyLinearProgress variant="determinate" value={95} />

        <p className={classes.heading}>Cameras</p>
        <MyLinearProgress variant="determinate" value={60} />

        <p className={classes.heading}>Audio</p>
        <MyLinearProgress variant="determinate" value={80} />

        <p className={classes.heading}>Battery</p>
        <MyLinearProgress variant="determinate" value={70} />

        <p className={classes.heading}>Features</p>
        <MyLinearProgress variant="determinate" value={90} />
      </div>
    </div>
  );
}
